/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_QcInputs */



/**
* | output |
* | --- |
* | "Found {count} events with QC issues in {group}" |
*
* @param {Assistant_Activity_QcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_qc = /** @type {((inputs: Assistant_Activity_QcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_QcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Des événements ${i?.count} présentant des problèmes de contrôle qualité ont été détectés dans ${i?.group}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Es wurden ${i?.count}-Ereignisse mit QC-Problemen in ${i?.group} gefunden.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sono stati rilevati ${i?.count} eventi con problemi di controllo qualità in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обнаружены события ${i?.count} с проблемами контроля качества в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se encontraron eventos ${i?.count} con problemas de control de calidad en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`在 ${i?.group} 中发现存在质量控制问题的 ${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} で QC の問題を抱えた ${i?.count} イベントが見つかりました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में QC संबंधी समस्याओं वाले ${i?.count} इवेंट पाए गए।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Foram encontrados ${i?.count} eventos com problemas de controle de qualidade em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Found ${i?.count} events with QC issues in ${i?.group}`)
});